module.exports = __webpack_public_path__ + "static/media/iconLaughter.92deaa3d.svg";